import { render, staticRenderFns } from "./LandingPageCreate.vue?vue&type=template&id=44a7df5c&scoped=true&"
import script from "./LandingPageCreate.vue?vue&type=script&lang=js&"
export * from "./LandingPageCreate.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageCreate.vue?vue&type=style&index=0&id=44a7df5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a7df5c",
  null
  
)

export default component.exports